<template>
  <div v-if="type === 'confirm'"  class="align-right padding10">
    <el-button @click="close" >取 消</el-button>
    <el-button type="primary" :loading="loading" @click="confirm">
      <slot v-if="!showPrint">确认</slot>
      <slot v-else>确认并打印</slot>
    </el-button>
  </div>
</template>
<script>
export default {
    name: `CloseButton`,
    props: {
        type: String,
        loading: { type: Boolean, default: false },
        msg: String,
        data: Object,
        showPrint: { type: Boolean, default: false }
    },
    methods: {
        close() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        },
        confirm() {
            this.$emit(`confirm`, this)
        }

    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/CloseButton.vue